module.exports = __webpack_public_path__ + "static/media/AM.8b42c952.svg";